<template>
  <Modal title="Импорт позиций" @backdrop-click="close">
    <template slot="body">
      <notifications group="import-modal" />
      <div class="body__wrapper">
        <p class="wrapper__tip">
          Пожалуйста, добавьте файл, содержащий новые
          и обновленные позиции, и отправьте форму
        </p>
        <FileInput
          accept-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          label="Добавить Excel-файл"
          @on-select-file="(selectedFile) => file = selectedFile"
          without-delete-button
        />
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons buttons__button_close-modal">
        <div>
          <button
            type="button"
            class="btn btn-danger"
            :disabled="isPending"
            @click="close"
          >
            Закрыть
          </button>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-success"
            :disabled="isPending"
            @click="handle"
          >
            <i class="fa fa-fw fa-upload" />
            Обработать
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/_shared/components/ui/Modal';
import FileInput from '@/_shared/components/ui/FileInput';
import { useNotification } from '@/_shared/mixins';
import { dataService } from '@/_shared/api-services';
export default {
  emits: ['close'],
  mixins: [useNotification],
  components: {
    Modal,
    FileInput,
  },
  data() {
    return {
      notificationGroup: 'import-modal',
      isPending: false,
      file: null,
    };
  },
  mounted() {
    document.querySelector("body").style.overflow = "hidden";
  },
  methods: {
    async handle() {
      this.isPending = true;
      const text = 'Файл обрабатывается. Пожалуйста, подождите';
      this.showWarningNotification(text)
      const { name } = this.$route;
      try {
        await dataService.importRecords(this.file, name)
          .then((response) => {
            const { message } = response.data;
            this.showSuccessNotification(message);
            setTimeout(this.$router.go, 2500);
          });
      } catch(error) {
        this.showErrorNotification(error.message);
        this.isPending = false;
      }
    },
    close() {
      if (this.isPending) {
        return;
      }
      document.querySelector("body").style.overflow = "auto";
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.body__wrapper {
  min-width: 400px;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.wrapper__tip {
  text-align: center;
  margin-bottom: 1.5em;
  max-width: 380px;
}
@media (max-width: 767px) {
  .body__wrapper {
    min-width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/modals/ImportModal.vue